// Generated by tools/icons/generate.mjs. Edit the SVG source and manifest instead.
import * as React from "react"
const ChevronUpIcon = /* @__PURE__ */ React.forwardRef<SVGSVGElement, React.ComponentProps<"svg">>((props, ref) => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.96967 15.0303C7.26256 15.3232 7.73744 15.3232 8.03033 15.0303L12.0303 11.0303C12.1793 10.8814 12.4207 10.8814 12.5697 11.0303L16.5697 15.0303C16.8626 15.3232 17.3374 15.3232 17.6303 15.0303C17.9232 14.7374 17.9232 14.2626 17.6303 13.9697L13.6303 9.96967C12.8956 9.23495 11.7044 9.23495 10.9697 9.96967L6.96967 13.9697C6.67678 14.2626 6.67678 14.7374 6.96967 15.0303Z"
        fill="currentColor"
      />
    </svg>
  )
})
ChevronUpIcon.displayName = "ChevronUpIcon"
export { ChevronUpIcon }
